import { timeCounter } from 'shared/utils/counters/timeCounter';
import { timeParserToInputValue } from '../../formFields/utils';

export const timeParser = (value: string) => {
    const time = timeParserToInputValue(value);
    return time ? timeCounter(time.minutes, time.hours) : value;
};
